import React, { useContext, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { PaginationComponent } from "../../components";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import SupervisorsTableComponent from "../../components/tables/SupervisorsTableComponent";
import PageLayout from "../../layouts/PageLayout";
import { listSupervisors } from "../../APIs/SupervisorRequests";
import { ButtonComponent } from "../../components/elements";
import { useLocation } from "react-router-dom";

export default function SupervisorsListPage() {

    const { t } = useContext(TranslatorContext);
    const [supervisors, setSupervisors] = React.useState([]);
    const [pagination, setPagination] = React.useState({});
    const [perPage, setPerPage] = React.useState(10);
    const [searchFilter, setSearchFilter] = React.useState('');

    const location = useLocation();
    const listSupervisorsFunction = (page=1) => {
        listSupervisors(page,perPage,searchFilter).then((res) => {
            setSupervisors(res.data.data);
            setPagination(res.data.pagination);
        }).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        listSupervisorsFunction();
    }, [perPage,searchFilter,location]);
    
    const redirectToCreatePage = () => {
        window.location.href = '/user-account?type=supervisor';
    };
    
    const thead = [t("name"), t("email"), t("status"), t("action")];

    const handlePageClick = (selected) => {
        listSupervisorsFunction(selected.selected + 1);
    }
    
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('supervisors_list')}</h3>
                            {
                                localStorage.getItem('permissions').includes('create supervisor') &&
                                <ButtonComponent  className="btn btn-primary m-2" onClick={redirectToCreatePage}>{ t('Create New') }</ButtonComponent>

                            }
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        
                        <Row xs={1} sm={2} xl={4}>
                            <Col>
                                <LabelFieldComponent
                                    label={t('show_by')}
                                    option={["10", "20", "50", "100"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        setPerPage(e.target.value);
                                    }}
                                />
                            </Col>
                            
                            
                            <Col>
                                <LabelFieldComponent
                                    type="search"
                                    label={t('search_by')}
                                    placeholder={t('id') + ' / ' + t('name') + ' / ' + t('email') + ' / ' + t('number')}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange={(e) => {
                                            setSearchFilter(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <SupervisorsTableComponent 
                            thead={ thead }
                            tbody={ supervisors }
                            refreshPage={ listSupervisorsFunction }
                        />
                        <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}